export const LOAD_DATA = 'LOAD_DATA';
export const SET_CONTINENT = 'SET_CONTINENT';
export const SET_COUNTRY = 'SET_COUNTRY';

// export const LOAD_FOR_SPECIFIC_DATE = 'LOAD_FOR_SPECIFIC_DATE';
